import {useEffect, useState} from "react";

/* eslint-disable-next-line */
declare var navigator: Navigator & {globalPrivacyControl: boolean};
const useGPCPopup = () => {
    const GPCP_COOKIE_NAME = 'gpcp';
    const GPCP_COOKIE_EXPIRE_DAYS = 365;
    const expires = new Date((GPCP_COOKIE_EXPIRE_DAYS * 24 * 60 * 60 * 1000) + Date.now()).toUTCString();

    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        window.setTimeout(
            () => {
                const gpcpCookie = document.cookie
                    .split("; ")
                    .find(cookie => cookie.startsWith(GPCP_COOKIE_NAME))?.startsWith(GPCP_COOKIE_NAME);

                const gpcEnabled = navigator.globalPrivacyControl !== null && navigator.globalPrivacyControl !== undefined ? navigator.globalPrivacyControl : false;

                setShowPopup(!gpcpCookie && gpcEnabled);
                document.cookie = `${GPCP_COOKIE_NAME}=1; expires=${expires}; SameSite=Lax; Secure`;
            }, 3000);
        }, []);

    return [showPopup, setShowPopup] as const;
}

export {useGPCPopup}